<template>
  <section>
    <br />
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="card" style="width: 400px">
          <header class="card-header">
            <p class="card-header-title">Wachtwoord Vergeten</p>
          </header>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input class="input" type="email" placeholder="Email-adres" v-model="user.Email" />
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Nieuw Wachtwoord</label>
              </div>
              <div class="field-body">
                <div class="field has-addons">
                  <div class="control is-expanded has-icons-left">
                    <div class="password">
                      <input
                        :class="'input ' + { valid: passwordValidation.valid }"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="user.Password"
                        placeholder="Typ hier uw wachtwoord..."
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-lock"></i>
                      </span>
                    </div>
                  </div>
                  <div class="control">
                    <button
                      class="button visibility"
                      tabindex="-1"
                      @click="togglePasswordVisibility"
                      :arial-label="passwordVisible ? 'Hide password' : 'Show password'"
                    >
                      <span class="icon is-small is-left">
                        <i :class="passwordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Herhaal Wachtwoord</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input
                      class="input"
                      type="password"
                      v-model.lazy="checkPassword"
                      placeholder="Herhaal nog eens uw wachtwoord"
                    />

                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal" v-if="user.Password != null && passwordValidation.errors.length > 0">
              <div class="field-label is-small">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <b-message
                  title="Het wachtwoord is nog niet correct"
                  type="is-danger"
                  size="is-small"
                  style=" width: -webkit-fill-available;"
                >
                  <div class="content is-danger">
                    <transition name="hint" appear>
                      <div v-if="passwordValidation.errors.length > 0 && !submitted" class="hints">
                        <p class="hint" v-for="error in passwordValidation.errors" :key="error.id">
                          {{ error }}
                        </p>
                      </div>
                    </transition>

                    <div class="matches" v-if="notSamePasswords">
                      <p>Passwords don't match.</p>
                    </div>
                  </div>
                </b-message>
              </div>
            </div>

            <div class="field is-horizontal" v-if="succes">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <br />
                    <b-message title="Success" type="is-success"
                      >Succesvol aangevraagd. Ga naar log-in scherm om in te loggen</b-message
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <p style="color: red">{{ errorMsg }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <vue-recaptcha
                    sitekey="6LejbMEUAAAAADfu5vt8NYuzJJsSl0rx07bMHJKv"
                    @verify="repatcha = $event"
                    @expired="repatcha = null"
                    size="width:400px"
                  ></vue-recaptcha>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <button @click="tryChangePassword" class="button is-primary is-fullwidth" :disabled="!(this.repatcha != null && this.$route.query.code)">
                      Verander wachtwoord
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import userService from '@/services/userService.js'
import router from '@/router/index.js'

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      user: { Email: '', Password: null },
      rules: [
        { id: 1, message: 'One lowercase letter required.', regex: /[a-z]+/ },
        { id: 2, message: 'One uppercase letter required.', regex: /[A-Z]+/ },
        { id: 3, message: '8 characters minimum.', regex: /.{8,}/ },
        { id: 4, message: 'One number required.', regex: /[0-9]+/ }
      ],
      repatcha: null,
      checkPassword: '',
      passwordVisible: false,
      submitted: false,
      errorMsg: '',
      succes: false
    }
  },

  computed: {
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.user.Password !== this.checkPassword
      }
      return false
    },
    passwordsFilled() {
      return this.user.Password !== '' && this.checkPassword !== ''
    },
    passwordValidation() {
      const errors = []
      for (const condition of this.rules) {
        if (!condition.regex.test(this.user.Password)) {
          errors.push(condition.message)
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors }
      }
      return { valid: false, errors }
    },

    code() {
      return this.$route.query.code
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },
    //async tryChangePassword() {
    //  if (this.passwordValidation.valid && this.repatcha != null) {
    //    //TODO: Server call change password en repatcha
    //    const model = {
    //      Email: this.user.Email,
    //      Password: this.user.Password,
    //      PasswordConfirmation: this.checkPassword,
    //      Code: this.code
    //    }
    //   const res = await userService.resetPassword(model)
    //    if (res == 'succeeded') {
    //      this.succes = true
    //      this.errorMsg = ''
    //    } else {
    //      this.errorMsg = 'Er is iets verkeerd gegaan'
    //    }
    //  }
    async tryChangePassword() {
      const code = unescape(this.$route.query.code)
      if (this.repatcha != null && code) {
      
      const model = { Email: this.user.Email, Password: this.user.Password, PasswordConfirmation: this.user.Password ,Code: code }
      console.log(model)
      
      //TODO: Server call change password en repatcha
        const res = await userService.resetPassword(model)

console.log('myresponse', res)

        if (res.status == 200) {
          this.success = true
          this.errorMsg = 'Wachtwoord is gewijzigd.'
        } else {
          this.errorMsg = 'Er is iets verkeerd gegaan.'
        }
        }
      else console.log('please use the repatcha widget')
    }
    }
  }

</script>

<style lang="css" scoped>
section {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/AuthForgot.vue